











































import Vue, { VueConstructor } from "vue";
import validationMixin from "@/components/mixins/validationMixin";
import policiesMixin from "@/components/mixins/policiesMixin";
import { FieldValues } from "@/models/policy";

export default (
  Vue as VueConstructor<
    Vue &
      InstanceType<typeof policiesMixin> &
      InstanceType<typeof validationMixin>
  >
).extend({
  name: "DisplayConfiguration",
  mixins: [validationMixin, policiesMixin],
  data() {
    return {
      fields: {} as { [key: string]: FieldValues },
      deviceDisplayModeOptions: [
        {
          value: 0,
          text: this.$t("policiesFields.DeviceDisplayModeDefault") as string,
        },
        {
          value: 1,
          text: this.$t("policiesFields.DeviceDisplayModeActive") as string,
        },
        {
          value: 2,
          text: this.$t("policiesFields.DeviceDisplayModePassive") as string,
        },
      ],
    };
  },

  methods: {
    onChangeDeviceDisplayMode(value: number) {
      this.fields.isActiveScreenEnforced = value == 1;
      this.fields.PassiveMonitorUsage = value == 2;
      this.onChange();
    },
  },
});
